import React, { useState } from 'react';
import { requestTypes } from '../../requests/constants';
import { RequestCalculator } from '../../requests/components/templates/RequestCalculationTemplate';
import { useRequestCalculationContext } from '../../requests/hooks/useRequestCalculation';

export function PriceCalculator({
  open,
  onClose,
  order,
  product,
  request,
  // Multi-main: array of `{product, request, listing?}` covering
  // every main slot (primary + additional). Forwarded to
  // CalcSummary so the popup renders all order items, not just
  // the first.
  mainEntries,
  pxRequests,
  pxProducts,
  client,
}) {
  const [openQuoteModal, setOpenQuoteModal] = useState(null);
  const {
    getSelectionForItem,
    results: { netPay, profit: [profitValue, profitErr] = [] },
    dealCurrency,
  } = useRequestCalculationContext();

  return (
    <RequestCalculator
      {...{
        isOrderFlow: true,
        openQuote: (quoteId, itemId) => {
          setOpenQuoteModal({ quoteId, itemId })
        },
        closeQuote: () => setOpenQuoteModal(null),
        orderFlowQuoteId: openQuoteModal?.quoteId,
        orderFlowItemId: openQuoteModal?.itemId,
        open,
        onClose,
        onCloseBtnClick: onClose,
        topTitle: 'LISTING',
        netPay,
        profitValue,
        profitErr,
        dealCurrency,
        requestType: requestTypes.PX_CART,
        order,
        product,
        request,
        mainEntries,
        pxRequests,
        pxProducts,
        client,
        getSelectionForItem,
      }}
    />
  );
}
